var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phone",
    transform: "translate(-163 -1083)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4779",
    "data-name": "Ellipse 4779",
    cx: 37,
    cy: 37,
    r: 37,
    transform: "translate(163 1083)",
    fill: "#f1f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "iphone",
    d: "M18.1,0H4.512A4.349,4.349,0,0,0,.168,4.344V36.5a4.348,4.348,0,0,0,4.344,4.344H18.1A4.349,4.349,0,0,0,22.445,36.5V4.344A4.349,4.349,0,0,0,18.1,0ZM11.307,37.129a1.857,1.857,0,1,1,1.856-1.857A1.856,1.856,0,0,1,11.307,37.129Zm2.785-31.56H8.522a.928.928,0,1,1,0-1.856h5.569a.928.928,0,0,1,0,1.856Zm0,0",
    transform: "translate(188.693 1099.579)",
    fill: "#66939e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.07dd1a8f13a4c70ead25024124d2da93.svg";
export { ForwardRef as ReactComponent };